var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPeople(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.719 19.7515L16.079 14.6275C15.9883 13.9017 15.6356 13.2341 15.0872 12.7501C14.5388 12.2662 13.8324 11.9992 13.101 11.9995H10.897C10.1659 11.9997 9.4601 12.2669 8.91211 12.7508C8.36411 13.2347 8.01168 13.9021 7.92102 14.6275L7.28002 19.7515C7.24484 20.033 7.26996 20.3188 7.3537 20.5899C7.43744 20.8609 7.57789 21.1111 7.76573 21.3237C7.95356 21.5363 8.18448 21.7065 8.44315 21.823C8.70182 21.9396 8.98232 21.9997 9.26602 21.9995H14.734C15.0176 21.9996 15.298 21.9393 15.5566 21.8227C15.8151 21.7061 16.0459 21.5359 16.2336 21.3233C16.4214 21.1107 16.5617 20.8606 16.6454 20.5896C16.7291 20.3186 16.7542 20.0329 16.719 19.7515V19.7515Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 7.99951C13.6569 7.99951 15 6.65637 15 4.99951C15 3.34266 13.6569 1.99951 12 1.99951C10.3431 1.99951 9 3.34266 9 4.99951C9 6.65637 10.3431 7.99951 12 7.99951Z",
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 10.9995C5.10457 10.9995 6 10.1041 6 8.99951C6 7.89494 5.10457 6.99951 4 6.99951C2.89543 6.99951 2 7.89494 2 8.99951C2 10.1041 2.89543 10.9995 4 10.9995Z",
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 10.9995C21.1046 10.9995 22 10.1041 22 8.99951C22 7.89494 21.1046 6.99951 20 6.99951C18.8954 6.99951 18 7.89494 18 8.99951C18 10.1041 18.8954 10.9995 20 10.9995Z",
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.00002 13.9995H3.69402C3.22059 13.9995 2.76248 14.1673 2.4012 14.4733C2.03992 14.7793 1.79891 15.2035 1.72102 15.6705L1.38802 17.6705C1.34024 17.9571 1.35545 18.2506 1.43259 18.5306C1.50974 18.8107 1.64698 19.0706 1.83475 19.2923C2.02253 19.5139 2.25634 19.692 2.51992 19.8142C2.7835 19.9363 3.07052 19.9995 3.36102 19.9995H7.00002M20 13.9995H20.306C20.7795 13.9995 21.2376 14.1673 21.5988 14.4733C21.9601 14.7793 22.2011 15.2035 22.279 15.6705L22.612 17.6705C22.6598 17.9571 22.6446 18.2506 22.5675 18.5306C22.4903 18.8107 22.3531 19.0706 22.1653 19.2923C21.9775 19.5139 21.7437 19.692 21.4801 19.8142C21.2166 19.9363 20.9295 19.9995 20.639 19.9995H17",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeople);
export default __webpack_public_path__ + "static/media/people.8e7193297ab88126fcbb099a9822a930.svg";
export { ForwardRef as ReactComponent };